// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__gHMPQ","col":"CardReaderDesc_col__26WSz","label":"CardReaderDesc_label__13ncu"};